// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSocialAccounts_container__1_5L2","label":"FormSocialAccounts_label__P3NVS","description":"FormSocialAccounts_description__2gEk1"};